import { FaHouseDamage, FaProjectDiagram, FaRegBuilding, FaUserCog, FaUsers, FaUsersCog } from 'react-icons/fa'
import { LuLayoutDashboard } from 'react-icons/lu'
import { MdFeedback, MdOutlineElectricMeter } from 'react-icons/md'
import { RiListSettingsLine } from 'react-icons/ri'
import { TbReport } from 'react-icons/tb'

const appRoutes = [
    {
        text: 'Menu',
        child: [
            {
                url: '/user',
                text: 'Dashboard',
                permission: 'dashboard',
                icon: <LuLayoutDashboard />,
            },
            {
                active: ['/user/roles'],
                url: '/user/roles',
                text: 'Roles',
                permission: 'roles.index',
                icon: <FaUserCog />,
            },
            {
                active: ['/user/users'],
                url: '/user/users',
                text: 'Users',
                permission: 'users.index',
                icon: <FaUsersCog />,
            },
            {
                active: ['/user/customers'],
                url: '/user/customers',
                text: 'Customer',
                permission: 'customers.index',
                icon: <FaRegBuilding />,
            },
            {
                active: ['/user/inspectors'],
                url: '/user/inspectors',
                text: 'Inspectors',
                permission: 'inspectors.index',
                icon: <FaUsers />,
            },
            {
                active: ['/user/projects'],
                url: '/user/projects',
                text: 'Projects',
                permission: 'projects.index',
                icon: <FaProjectDiagram />,
            },
            {
                active: ['/user/transformers'],
                url: '/user/transformers',
                text: 'Transformers',
                permission: 'transformers.index',
                icon: <FaHouseDamage />,
            },
            {
                active: ['/user/test-types'],
                url: '/user/test-types',
                text: 'Test Data',
                permission: 'test_types.index',
                icon: <RiListSettingsLine />,
            },
            {
                active: ['/user/transformer-tests'],
                url: '/user/transformer-tests',
                text: 'Test Groups',
                permission: 'transformer_tests.index',
                icon: <MdOutlineElectricMeter />,
            },
            {
                active: ['/user/feedbacks'],
                url: '/user/feedbacks',
                text: 'Feedbacks',
                permission: 'feedbacks.index',
                icon: <MdFeedback />,
            },
            {
                active: [
                    '/user/reports/customer-satisfaction',
                    '/user/reports/monthly-customer-satisfaction',
                    '/user/reports/customer-comments',
                ],
                text: 'Reports',
                icon: <TbReport />,
                permission: 'feedbacks.reports',
                child: [
                    {
                        active: ['/user/reports/customer-satisfaction'],
                        url: '/user/reports/customer-satisfaction',
                        text: 'Customer Satisfaction',
                    },
                    {
                        active: ['/user/reports/monthly-customer-satisfaction'],
                        url: '/user/reports/monthly-customer-satisfaction',
                        text: 'Monthly Satisfaction',
                    },
                    {
                        active: ['/user/reports/customer-comments'],
                        url: '/user/reports/customer-comments',
                        text: 'Customer Comments',
                    },
                ],
            },
        ],
    },
]

export default appRoutes
